module.exports = __webpack_public_path__ + "static/media/woocommerce-logo.ce9a19d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/newDropshipperApp/images/woocommerce-logo.png
// module id = 2771
// module chunks = 0